import Vue from 'vue';
import { VDataTable } from 'vuetify/lib';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        options: {
            customProperties: true, // <--- ESTO ES VITAL
        },
        themes: {
            /*light: {
                // 1. Regresamos el primary al Teal base
                primary: '#009688',
                secondary: '#80cbc4',

                // 2. Restauramos el objeto 'teal' con sus tonos originales
                teal: {
                    base: '#009688',      // Teal estándar
                    lighten5: '#e0f2f1',
                    lighten4: '#b2dfdb',
                    lighten3: '#80cbc4',
                    darken1: '#00897b',   // El que usará tu v-card-title
                    darken2: '#00796b',
                    darken3: '#00695c',   // El azuloso oscuro de tu barra superior
                    darken4: '#004d40',   // El profundo de los menús
                }
            },*/
            light: {
                /// 1. Definimos tu verde como el color primario
                primary: '#4caf50',
                secondary: '#a5d6a7',

                // 2. SOBRESCRIBIMOS el objeto 'teal' 
                // Ahora, cuando pongas "teal" en el HTML, Vuetify usará estos:
                teal: {
                    base: '#4caf50',      // El verde que quieres
                    lighten4: '#e8f5e9',
                    lighten3: '#c8e6c9',
                    darken1: '#43a047',   // <--- AÑADE ESTO (Es el que usa tu v-card-title)
                    darken2: '#388e3c',
                    darken3: '#2e7d32',   // Un verde oscuro elegante para la barra
                    darken4: '#1b5e20',   // Aún más oscuro para los menús
                }
            },
        },
    },
    VDataTable: {
        dataTableFooterProps: {
            'items-per-page-text': 'Filas por página:',
            'items-per-page-all-text': 'Todos', // <-- ¡Esta es la clave de prop que funciona!
            'page-text': '{0}-{1} de {2}'      // <-- ¡Esta es la clave de prop que funciona!
        },

        // 2. INYECTAR PROPS DEL CUERPO DE LA TABLA DIRECTAMENTE
        'no-data-text': 'No hay datos disponibles',
        'no-results-text': 'No se encontraron registros',
        'loading-text': 'Cargando... Por favor, espere'
    }

});
